import { theme } from "../../../config/config";
import { ThemeProvider } from "@mui/material/styles";
import Leasetype from "../FormComponent/Leasetype";
import InvAndProps from "../FormComponent/InvAndProps";
import PropManager from "../FormComponent/PropManager";
import Tenant from "../FormComponent/NewLeaseTenant";
import AmendmentTenant from "../FormComponent/NewLeaseAmendmentTenant";
import {
  CircularProgress,
  Paper,
  Snackbar,
  Alert,
  Button,
  Box,
} from "@mui/material";
import KeyDates from "../FormComponent/KeyDates";
import SupportingData from "../FormComponent/SupportingData";
import ActionButtons from "../ActionButtons/actionButton";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { useEffect, useState } from "react";
import { getInvData } from "../../../redux/slices/investmentSlice";
import { getAllTenantData } from "../../../redux/slices/allStandardTenantSlice";
import {
  setShowValidationMessage,
  setShowSuccessMessage,
} from "../../../redux/slices/formValidationSlice";
import { allSelectedData } from "../../../redux/slices/allSelectedDataSlice";
import { useParams } from "react-router-dom";
import {
  getPropertyManagerData,
  getSecondaryPropertyManagerData,
} from "../../../redux/slices/propertyManagerSlice";
import { getPropertyData } from "../../../redux/slices/propertyslice";
import { getLeaseData } from "../../../redux/slices/leaseByIdSlice";
import { getTenantByPropertyData } from "../../../redux/slices/AmendmentTenatByPropertyDataSlice";
import AuditButton from "../Audit/auditButton";

const LeaseForm = (props: any) => {
  const dispatch = useAppDispatch();
  const invDataLoading = useAppSelector((state) => state.invData.loading);
  const { showValidationMessage, showSuccessMessage } = useAppSelector(
    (state) => state.formValidation
  );
  const selectedData = useAppSelector((state) => state.allSelectedData);
  const dataById = useAppSelector((state) => state.leaseDatabyId.data.result);
  const { formtype, itemid }: any = useParams();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(getInvData());
    dispatch(getAllTenantData());
    if (["edit", "view", "approval"].includes(formtype) && itemid) {
      dispatch(getLeaseData(itemid));
    } else if (formtype === "new") {
      dispatch(
        allSelectedData({
          ...selectedData,
          leaseType: "New Lease",
        })
      );
    }
  }, [formtype, itemid]);

  useEffect(() => {
    if (formtype === "edit" && itemid && dataById) {
      const transformedData = {
        ...dataById,
        abstractStatus:
          dataById.abstractStatus?.find((item: any) => item.isSelected)
            ?.value || "",
        subjectToSLR:
          dataById.subjectToSLR?.find((item: any) => item.isSelected)?.value ||
          "",
      };
      dispatch(allSelectedData(transformedData));
      dispatch(getPropertyManagerData(dataById.propertyId));
      dispatch(getSecondaryPropertyManagerData(dataById.propertyId));
      dispatch(getPropertyData(dataById.investmentId));
      dispatch(getTenantByPropertyData(dataById.propertyId));
    }
  }, [dataById]);

  useEffect(() => {
    if (
      (formtype === "view" || formtype === "approval") &&
      itemid &&
      dataById
    ) {
      const transformedData = {
        ...dataById,
        abstractStatus:
          dataById.abstractStatus?.find((item: any) => item.isSelected)
            ?.value || "",
        subjectToSLR:
          dataById.subjectToSLR?.find((item: any) => item.isSelected)?.value ||
          "",
      };
      dispatch(allSelectedData(transformedData));
    }
  }, [dataById]);

  const handleCloseSnackbar = () => {
    dispatch(setShowValidationMessage(false));
  };

  return (
    <>
      {!invDataLoading && !loading ? (
        <div>
          <Paper
            elevation={3}
            sx={{
              padding: 3,
              margin: 2,
              backgroundColor: "#fff",
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
              {formtype !== "new" && <AuditButton />}
            </Box>
            <div className="form-dv">
              <ThemeProvider theme={theme}>
                <Leasetype />
                <InvAndProps />
                <PropManager />
                {selectedData.leaseType === "New Lease" && <Tenant />}
                {selectedData.leaseType === "Lease Amendment" && (
                  <AmendmentTenant />
                )}
                <KeyDates />
                <SupportingData />
              </ThemeProvider>
            </div>
          </Paper>
          <Paper
            elevation={3}
            sx={{
              backgroundColor: "#fff",
              position: "sticky",
              bottom: 0,
              left: 0,
              right: 0,
              padding: 1,
              margin: 2,
              zIndex: 1000,
              marginTop: "auto",
            }}
          >
            <ActionButtons />
          </Paper>

          <Snackbar
            open={showValidationMessage}
            autoHideDuration={6000}
            onClose={handleCloseSnackbar}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <Alert
              onClose={handleCloseSnackbar}
              severity="error"
              sx={{ width: "100%" }}
            >
              Please fix the validation errors before saving.
            </Alert>
          </Snackbar>
          <Snackbar
            open={showSuccessMessage}
            autoHideDuration={4000}
            onClose={() => dispatch(setShowSuccessMessage(false))}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <Alert
              onClose={() => dispatch(setShowSuccessMessage(false))}
              severity="success"
              sx={{ width: "100%" }}
            >
              Operation completed successfully!
            </Alert>
          </Snackbar>
        </div>
      ) : (
        <div className="loading-backdrop loading-backdrop-full">
          <CircularProgress />
        </div>
      )}
    </>
  );
};

export default LeaseForm;
